module.exports = __webpack_public_path__ + "img/tel.a41e3232.png";